var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"element-type":_vm.elementType}},[_c('div',{ref:"mapContainer",class:[_vm.containerClasses],staticStyle:{"width":"100%"},style:(_vm.style)})])}
var staticRenderFns = []

export { render, staticRenderFns }